export const PATHOGEN_PROTEINS = [
  'N', 'M', 'E', 'spike', 'nsp1', 'nsp2', 'nsp3', 'nsp4', 'nsp5', 'nsp6', 'nsp7', 'nsp8', 'nsp9', 'nsp10', 'nsp11', 'nsp12', 'nsp13', 'nsp14', 'nsp15', 'nsp16',
  'ORF3',  'ORF3a', 'ORF3b', 'ORF4a', 'ORF5', 'ORF6', 'ORF7a', 'ORF7b', 'ORF8', 'ORF9b', 'ORF9c', 'ORF10'
];

export const env = {
  BASE_URL: '/'
}
